module.exports = __webpack_public_path__ + "static/site-1748617940196/img/mercadopago-logo.f9ae46a8.webp";